/** @graphql cc **/
import gql from 'graphql-tag';

export const UserContextQuery = gql`
	query UserContextQuery {
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			emails {
				value
				isPrimary
			}
		}
	}
`;
